import React from "react";
import { FiX } from "react-icons/fi";

/** Title row shared by the account settings modals. */
export const AccountModalHeader = ({
  title,
  description,
  icon,
  onClose,
  titleId,
}: {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  onClose?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  titleId?: string;
}) => (
  <div className="flex items-start justify-between gap-4 px-5 pt-5 pb-4 border-b sm:px-6 border-line">
    <div className="flex items-start min-w-0 gap-3">
      {icon && (
        <span className="inline-flex items-center justify-center rounded w-9 h-9 shrink-0 bg-primary-soft text-primary-text">
          {icon}
        </span>
      )}
      <div className="min-w-0">
        <h2 id={titleId} className="text-base font-semibold font-display text-ink">
          {title}
        </h2>
        {description && <p className="mt-1 text-sm text-ink-3">{description}</p>}
      </div>
    </div>
    {onClose && (
      <button type="button" className="-mt-1 -mr-2 zs-icon-btn shrink-0" onClick={onClose} aria-label="Close">
        <FiX />
      </button>
    )}
  </div>
);

export const AccountModalBody = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => (
  <div className={`flex flex-col gap-4 px-5 py-5 sm:px-6 ${className}`}>{children}</div>
);

export const AccountModalFooter = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => (
  <div
    className={`flex flex-col-reverse gap-2 px-5 py-4 border-t sm:flex-row sm:items-center sm:justify-end sm:px-6 border-line bg-surface-2 rounded-b-xl ${className}`}
  >
    {children}
  </div>
);
